import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS, CLIENT_HEALTH_INSURANCE_NEW } from 'src/constants/EndpointUrls';
import { CLIENT_ACCIDENT_INSURANCE_FORM } from 'src/constants/FormNames';
import { REDUCER_NAME, saveClientAccidentInsurance } from 'src/reducers/clients/insurance';
import { setItem, getItem, getItemErrors } from 'src/reducers/common/itemReducer';
import { setList, setExtras } from 'src/reducers/common/listReducer';
import AccidentInsuranceCreatingForm from './container/AccidentInsuranceCreatingFormContainer';

let ClientAccidentInsuranceForm = reduxForm({
  form: CLIENT_ACCIDENT_INSURANCE_FORM
})(AccidentInsuranceCreatingForm);

const mapStateToProps = state => ({
  errors: getItemErrors(REDUCER_NAME, state),
  initialValues: {
    ...(getItem(REDUCER_NAME, state) || {})
  }
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(saveClientAccidentInsurance(data));
  }
});

ClientAccidentInsuranceForm = connect(mapStateToProps, mapDispatchToProps)(ClientAccidentInsuranceForm);

const NewClientAccidentInsurance = ({ dispatch, values }) => {
  dispatch(setItem(REDUCER_NAME, values.insurance));
  dispatch(setList(REDUCER_NAME, { data: values.insurances }));
  dispatch(setExtras(REDUCER_NAME, values.extras));

  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">社会保険設定</h1>
      </div>
      <div className="l-wrap-xs l-contents-wrap">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label="設定" path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label="社会保険設定" path={CLIENT_HEALTH_INSURANCE_NEW} />
            <BreadCrumb.Item label="労災保険" />
          </BreadCrumb>
        </div>
      </div>
      <ClientAccidentInsuranceForm />
    </div>
  );
};

export default connect()(NewClientAccidentInsurance);
